<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Período de Formação
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="6">
                <v-text-field
                  v-model="formattedDataInicio"
                  label="Início do Período"
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="formattedDataFim"
                  label="Fim do Período"
                  outlined
                  dense
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
            <v-col cols="12">
              <span class="small">Perfil</span>
              <div class="perfil-box">
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="perfil in content.perfis" :key="perfil.id">
                    {{ perfil.nome }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-col>
          </v-row>
          </v-form>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" outline @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { PeriodoFormacao } from '~/commons/classes/periodo-formacao';

export default {
  props: new DialogProps(PeriodoFormacao),
  computed: {
    formattedDataInicio() {
      return this.formatDate(this.content.dataInicio);
    },
    formattedDataFim() {
      return this.formatDate(this.content.dataFim);
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(date).toLocaleDateString('pt-BR', options);
    }
  }
};
</script>
<style scoped>
.perfil-box {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}
</style>